<template>
    <!--
    Main content component.
    Usually content gets rendered into the components slot.
    Pages containing a sub navigation, don't need this component.
    -->
    <div class="content-main" :class="style" v-if="showContent">
        <slot />
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default
{
    name: 'MainContent',

    props: ['blank'],

    data()
    {
        return {
            style: '',
        }
    },

    created()
    {
        this.style = (typeof this.blank == 'undefined') ? this.style : 'content-main--blank';
    },

    computed:
    {
        showContent()
        {
            // Hide content if tabbed view with main content tab
            if (this.isMobile && this.mainContentTab) {
                return this.activeTab == 0;
            }

            return true;
        },

        // Is viewport in mobile mode
        isMobile()
        {
            return this.viewport != 'd' && this.viewport != 'tl';
        },

        ...mapState({
            viewport: ({ layout }) => layout.viewport,
            activeTab: ({ sidebar }) => sidebar.tab.activeTab,
            mainContentTab: ({ sidebar }) => sidebar.tab.mainContentTab,
        }),
    },
}
</script>



// WEBPACK FOOTER //
// MainContent.vue?06c87bea